export const sleep = async (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const isStringArray = (arr) => {
  return arr.every((item) => typeof item === 'string')
}

export const waitForCondition = async (
  conditionFn,
  timeout = 2000,
  interval = 100,
) => {
  const startTime = Date.now()
  while (Date.now() - startTime < timeout) {
    if (conditionFn()) {
      return true
    }
    await sleep(interval)
  }
  return false
}
